export default ({ style }) => (
  <svg width="302" height="295" viewBox="0 0 302 295" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      d="M8.3445 45.5229L0.402608 48.5515C0.671784 54.8704 7.59217 57.5825 9.81722 57.8043L27.103 51.2124C20.6068 53.2616 10.1551 48.3999 8.3445 45.5229Z"
      fill="#FFE0A1"
    />
    <path
      d="M243.558 13.2622L242.075 21.6316C247.634 24.6478 253.517 20.1049 254.851 18.3101L258.079 0.0938563C256.498 6.71974 246.957 13.1874 243.558 13.2622Z"
      fill="#FFB3B3"
    />
    <path
      d="M301.941 99.0349L300.452 107.403C294.194 108.321 290.235 102.031 289.601 99.8863L292.842 81.6724C292.044 88.4373 298.776 97.7946 301.941 99.0349Z"
      fill="#B0FFCB"
    />
    <path
      d="M25.6998 242.225L32.1157 247.8C37.5609 244.583 36.6891 237.201 35.8353 235.135L21.871 223C26.7415 227.762 27.383 239.271 25.6998 242.225Z"
      fill="#FFB3B3"
    />
    <path
      d="M61.6998 66.2247L68.1157 71.7999C73.5609 68.5828 72.6891 61.2012 71.8353 59.1346L57.871 47C62.7415 51.7622 63.383 63.2714 61.6998 66.2247Z"
      fill="#B0BEFF"
    />
    <path
      d="M267.995 282.569L261.08 287.51C262.94 293.555 270.322 294.426 272.531 294.077L287.583 283.322C281.818 286.949 270.476 284.894 267.995 282.569Z"
      fill="#97ECFF"
    />
  </svg>
)
